module.exports = __webpack_public_path__ + "media/กูน่ะแก่แล้ว_แต่กูยังโคยแข็ง.6d793606.mp3";